module.exports = __webpack_public_path__ + "img/clock.70cff7bf.svg";